import { render } from "./Proveedor_Producto_Precio.vue?vue&type=template&id=f454b7ae"
import script from "./Proveedor_Producto_Precio.vue?vue&type=script&lang=js"
export * from "./Proveedor_Producto_Precio.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__